import React from 'react';
import styled from 'styled-components';

import ExpandableArrow from 'components/basic/icons/ExpandableArrow';
import { CoinIcon } from 'config/coinIcons/CoinIcon';
import { openMarketsSidebar } from 'reduxState/markets/marketsSidebar';
import { useSelector, staticDispatch } from 'reduxState/store';

import MarketsTickersScreen from './marketsScreen/MarketsTickersScreen';

const Heading = styled.h2<{ padding?: string }>`
  font-weight: normal;
  font-size: var(--small);
  display: flex;
  align-items: center;
  color: var(--gray4a);
  ${props => (props.padding ? `padding: ${props.padding}` : 'padding: 8px 0;')};
  cursor: pointer;
`;

const White = styled.div`
  color: var(--white);
`;

function MarketSelectorMobile() {
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const { base, quote } = currentMarket;

  return (
    <>
      <MarketsTickersScreen />
      <Heading onClick={() => staticDispatch(openMarketsSidebar())}>
        {base && <CoinIcon symbol={base} size="16px" />}&nbsp;{' '}
        <White>{base}</White>-{quote}
        &nbsp;
        <ExpandableArrow expanded={false} />
      </Heading>
    </>
  );
}

export default MarketSelectorMobile;
